/*
 *   File : dashboard.js
 *   Author : https://evoqins.com
 *   Description : Dashboard page of indvestment
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

//Custom components
import { AlphaBasketCard, CategoryCard, CategoryTab } from '../../Component/Cards';
import { Icon } from '../../Component/Icon';
import CreatorSlider from '../../Component/Slider/creator-slider';
import { APIService } from '../../Service';
import { EmptyScreen, Loader } from '../../Component/Others';
import { _scrollToTop } from '../../Helper';

//style
import style from "../../Styles/Component/dashboard.module.scss";

// Assets
import EmptyData from "../../Assets/Images/EmptyScreen/empty-data.webp";

const TOP_PRODUCT_TAB = [
    {
        id: "alpha_basket",
        label: "alphaBasket"
    },
    {
        id: "alpha_basket_pro",
        label: "alphaBasket pro"
    },
    // {
    //     id: 3,
    //     label: "alphaStocks"
    // },
    // {
    //     id: 4,
    //     label: "alphaOptions"
    // },
    // {
    //     id: 5,
    //     label: "alphaMF"
    // },
];

const CATEGORIES = [
    {
        id: 1,
        category: "alphaBasket",
        description: "Curated basket of stocks"
    },
    {
        id: 2,
        category: "alphaBasket pro",
        description: "Curated basket of stocks based on your risk profile"
    },
    // {
    //     id: 3,
    //     category: "alphaStocks",
    //     description: "Stocks recommendations from experts"
    // },
    // {
    //     id: 4,
    //     category: "alphaOptions",
    //     description: "F&O recommendations from experts"
    // },
    // {
    //     id: 5,
    //     category: "alphaMF",
    //     description: "Mutual fund recommendations from advisors"
    // },
];

const Dashboard = () => {

    const USER_DATA = useSelector((store) => store.Reducer.USER_DATA);

    const swiperRef = useRef(null);
    const navigate = useNavigate();
    const { state } = useLocation();

    const [homeData, setHomeData] = useState({});
    const [products, setProducts] = useState([]);
    const [loadingHomeData, setLoadingHomeData] = useState(true);
    const [selectedTab, setSelectedTab] = useState(state !== null ? state : "alpha_basket");

    useEffect(() => {
        if (USER_DATA) {
            // API - get home data
            _getHomeData();
        }
        // Scroll the page to top
        _scrollToTop();
    }, [USER_DATA]);

    // handle category tab 
    const _handleTabChange = (id) => {
        navigate("/", {
            state: id
        });
        setSelectedTab(id);
        setProducts(homeData.top_products[id].products);
    };

    // handle navigate to brokers list 
    const _handleNavigateBrokers = () => {
        navigate("/account/brokers");
    };

    // handle previous slider 
    const _handlePrev = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slidePrev();
        }
    };

    // handle next slider 
    const _handleNext = () => {
        if (swiperRef.current && swiperRef.current.swiper) {
            swiperRef.current.swiper.slideNext();
        }
    };

    // handle navigate to explore 
    const _handleNavigateExplore = (id) => {
        if (id < 3) {
            navigate("/explore", {
                state: {
                    tab_index: 1,
                    category_tab: id
                }
            });
        }
    };

    // handle navigate basket detail 
    const _handleBasketDetail = (strategy_id) => {
        navigate("/explore/strategy-detail", {
            state: {
                "strategy_id": Number(strategy_id),
            }
        });
    };

    // handle navigate to creator detail 
    const _handleNavigateCreatorDetail = (creator_id) => {
        navigate("/explore/creator-detail", {
            state: {
                creator_id: Number(creator_id)
            }
        });
    };

    // ===================================== //
    // ============ API CALLS ============== //

    // Send Signup OTP to mobile
    const _getHomeData = async () => {
        let url = "home/get";
        let data = {
            "user_id": USER_DATA && USER_DATA.unique_identifier
        };

        const response = await APIService(url, data)
        if (response.status_code === 200) {
            setHomeData(response.data);
            setProducts(response.data.top_products[selectedTab].products);
        } else {
            setHomeData("");
        }
        setLoadingHomeData(false);
    };

    return (
        <section className='min-vh-100'>
            {
                loadingHomeData ?
                    <Loader wrapperClassName="h-100 margin-200px-top" />
                    :
                    <>
                        {/* Banner  */}
                        <div className={`${style.e_top_banner_wrapper} border-radius-16 e-padding-16px-all-res px-sm-4 padding-20px-tb`}>
                            <p className='e-font-14-res margin-2px-bottom e-primary-font-clash-display e-text-white e-font-16 e-font-weight-400 line-height-24px'>
                                Hi {USER_DATA.first_name} {USER_DATA.middle_name} {USER_DATA.last_name} !
                            </p>
                            <h6 className='e-font-18-res mb-3 e-primary-font-clash-display e-text-white e-font-20 e-font-weight-500 line-height-24px'>
                                Let's start Investing!
                            </h6>

                            <div className='row'>
                                <div className='col-auto'>
                                    <div className={`${style.e_discover_wrapper} padding-6px-tb px-2 border-radius-16 position-relative overflow-hidden`}>
                                        <div className='d-flex gap-3 align-items-center'>
                                            <div>
                                                <img src={require("../../Assets/Images/Dashboard/video-img.png")}
                                                    draggable={false}
                                                    width={80}
                                                    alt='video' />
                                            </div>
                                            <div>
                                                <h6 className='e-font-14-res mb-1 e-alt-font-lato e-text-chinese-black e-font-16 e-font-weight-600 line-height-24px'>
                                                    Discover Indvestment
                                                </h6>
                                                <p className='e-font-12-res mb-0 pe-sm-5 e-alt-font-lato e-text-outer-space e-font-14 e-font-weight-400 line-height-20px'>
                                                    Personalized investment strategies for optimal <br className='d-none d-md-block' /> financial growth.
                                                </p>
                                            </div>
                                        </div>
                                        <img src={require("../../Assets/Images/Dashboard/discover-icon.svg").default}
                                            draggable={false}
                                            className='position-absolute top-0 end-0 w-32px-res'
                                            alt='icon' />
                                    </div>
                                </div>
                            </div>

                        </div>

                        {/* Top Categories  */}
                        <div className='pt-3 pt-sm-4 mt-2'>
                            <h4 className='e-font-16-res e-primary-font-clash-display e-text-chinese-back e-font-18 e-font-weight-500 line-height-24px'>
                                Top Categories
                            </h4>
                            <div className='pt-3 pt-sm-4 row row-gap-4 overflow-auto no-scrollbar flex-nowrap flex-sm-wrap'>
                                {
                                    CATEGORIES.map((categories, key) => (
                                        <div key={key} className='col-10 col-sm-6 col-md-4' >
                                            <CategoryCard category={categories}
                                                handleClick={_handleNavigateExplore} />
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        {/* Top Creators  */}
                        <div className='pt-3 pt-s-m-4 mt-2'>
                            <div className='d-flex align-items-center justify-content-between'>
                                <h4 className='e-font-16-res mb-0 e-primary-font-clash-display e-text-chinese-back e-font-18 e-font-weight-500 line-height-24px'>
                                    Top Creators
                                </h4>

                                {/* Slider arrows */}
                                {
                                    homeData?.top_creators?.length > 2 &&
                                    <div className='d-flex gap-12px'>
                                        <div className='w-32px-res h-32px-res d-flex justify-content-center align-items-center border-radius-32 e-bg-magnolia e-border-0-5px-lavender-light p-2 cursor-pointer'
                                            onClick={_handlePrev}>
                                            <Icon icon="arrow-right"
                                                size="16px"
                                                color="#48464C"
                                                className="e-rotate-180 d-flex h-14px-res" />
                                        </div>
                                        <div className='w-32px-res h-32px-res d-flex justify-content-center align-items-center border-radius-32 e-bg-magnolia e-border-0-5px-lavender-light p-sm-2 cursor-pointer'
                                            onClick={_handleNext}>
                                            <Icon icon="arrow-right"
                                                className="d-flex h-14px-res"
                                                color="#48464C"
                                                size="16px" />
                                        </div>
                                    </div>
                                }
                            </div>
                            {/* Creator slider */}
                            <div className='pt-3'>
                                <CreatorSlider ref={swiperRef}
                                    data={homeData.top_creators}
                                    handleClick={_handleNavigateCreatorDetail} />
                            </div>
                        </div>

                        {/* Top Products */}
                        <div className='pt-3 pt-sm-4 mt-2 mb-5'>
                            <h4 className='e-font-16-res margin-12px-bottom e-primary-font-clash-display e-text-chinese-back e-font-18 e-font-weight-500 line-height-24px'>
                                Top Products
                            </h4>
                            {/* Category tab section */}
                            <div className='e-bg-magnolia-extra-light px-sm-3 padding-20px-tb e-padding-8px-all-res'>
                                <div className='d-flex gap-3'>
                                    <CategoryTab data={TOP_PRODUCT_TAB}
                                        activeTab={selectedTab}
                                        handleTabChange={_handleTabChange} />
                                </div>
                            </div>

                            {/* AlphaBasket card */}

                            <div className='row row-gap-4 padding-12px-top'>
                                {
                                    products.length !== 0 ?
                                        products.map((product, key) => (
                                            <div key={key} className='col-md-6'>
                                                <AlphaBasketCard product={product}
                                                    category={selectedTab === "alpha_basket" ? 1 : 2}
                                                    handleClick={() => _handleBasketDetail(product.strategy_id)} />
                                            </div>
                                        ))
                                        :
                                        <EmptyScreen type={1}
                                            emptyScreenImage={EmptyData}
                                            description="There is no products to show, please try with different categories" />
                                }
                            </div>



                        </div>

                        {/* Put your money to work banner */}
                        {
                            USER_DATA && USER_DATA.user_brokers_info && USER_DATA.user_brokers_info.length === 0 &&
                            <div className='py-4 mt-2'>
                                <div className={`${style.e_money_to_work_banner} border-radius-16 px-3 px-sm-4 cursor-pointer`}
                                    onClick={_handleNavigateBrokers} >
                                    <div className='row'>
                                        <div className='col-8 my-auto'>
                                            <h4 className='e-font-16-res mb-3 e-primary-font-clash-display e-text-white e-font-24 e-font-weight-500 line-height-24px'>
                                                Put your money to work
                                            </h4>
                                            <div className='d-flex gap-2px align-items-center'>
                                                <span className=' e-alt-font-lato e-text-white e-font-14 e-font-weight-600 line-height-16px'>
                                                    Connect with stock brokers
                                                </span>
                                                <Icon icon="right-arrow"
                                                    color="#FFFFFF"
                                                    className="d-flex transition"
                                                    size="18px" />
                                            </div>
                                        </div>
                                        <div className='col-4 text-center'>
                                            <img src={require("../../Assets/Images/Dashboard/money-to-work-img.png")}
                                                draggable={false}
                                                className='img-fluid width-184px h-128 object-fit-contain'
                                                alt='banner-img' />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
            }
        </section>
    )
}

export default Dashboard;
